import Steps from './steps';
import StepsItem from './steps-item';
var DefaultSteps = Steps;
DefaultSteps.Step = StepsItem;
export default DefaultSteps;
//# sourceMappingURL=index.js.map